// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9JN17","footer":"styles_footer__2Ejg7"};